/**
 * @generated SignedSource<<413c14dcd45749c28d5e75103613e951>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type suggestions_periscope_SuggestionsPanel_fragmentRef$data = {
  readonly workSuggestions: {
    readonly suggestionsByProjects: {
      readonly autoDevJobsSuggestions?: ReadonlyArray<{
        readonly __typename: string;
        readonly id: string;
        readonly orderScore: {
          readonly byTaskType: {
            readonly major: number;
            readonly minor: AGG$Long | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"suggestions_periscope_WorkSuggestionsAutoDevJobSwitcher_node">;
      }> | null | undefined;
      readonly commonSuggestions: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: string;
            readonly id: string;
            readonly orderScore: {
              readonly byTaskType: {
                readonly major: number;
                readonly minor: AGG$Long | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly " $fragmentSpreads": FragmentRefs<"suggestions_periscope_WorkSuggestionsSwitcher_node">;
          } | null | undefined;
        }> | null | undefined;
      } | null | undefined;
      readonly compassSuggestions?: ReadonlyArray<{
        readonly __typename: string;
        readonly id: string;
        readonly orderScore: {
          readonly byTaskType: {
            readonly major: number;
            readonly minor: AGG$Long | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"suggestions_periscope_WorkSuggestionsCompassSuggestionsSwitcher_node">;
      }> | null | undefined;
      readonly pullRequestSuggestions?: ReadonlyArray<{
        readonly __typename: string;
        readonly id: string;
        readonly orderScore: {
          readonly byTaskType: {
            readonly major: number;
            readonly minor: AGG$Long | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"suggestions_periscope_WorkSuggestionsPullRequestsSuggestionsSwitcher_node">;
      }> | null | undefined;
      readonly sortOrder: {
        readonly defaultOrder: ReadonlyArray<string>;
      } | null | undefined;
    } | null | undefined;
  };
  readonly " $fragmentType": "suggestions_periscope_SuggestionsPanel_fragmentRef";
};
export type suggestions_periscope_SuggestionsPanel_fragmentRef$key = {
  readonly " $data"?: suggestions_periscope_SuggestionsPanel_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"suggestions_periscope_SuggestionsPanel_fragmentRef">;
};

import periscopeRefetchableQuery_graphql from './periscopeRefetchableQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "workSuggestions",
  "suggestionsByProjects",
  "commonSuggestions"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "concreteType": "WorkSuggestionsOrderScore",
  "kind": "LinkedField",
  "name": "orderScore",
  "plural": false,
  "selections": [
    {
      "concreteType": "WorkSuggestionsOrderScores",
      "kind": "LinkedField",
      "name": "byTaskType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "major"
        },
        {
          "kind": "ScalarField",
          "name": "minor"
        }
      ]
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAutoDevJobsSuggestionEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isCompassSuggestionsEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isPullRequestSuggestionsEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectAris"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sprintAutoDiscoveryLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": periscopeRefetchableQuery_graphql
    }
  },
  "name": "suggestions_periscope_SuggestionsPanel_fragmentRef",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "WorkSuggestions",
        "kind": "LinkedField",
        "name": "workSuggestions",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "projectAris",
                "variableName": "projectAris"
              },
              {
                "kind": "Variable",
                "name": "sprintAutoDiscoveryLimit",
                "variableName": "sprintAutoDiscoveryLimit"
              }
            ],
            "concreteType": "WorkSuggestionsByProjectsResponse",
            "kind": "LinkedField",
            "name": "suggestionsByProjects",
            "plural": false,
            "selections": [
              {
                "alias": "commonSuggestions",
                "concreteType": "WorkSuggestionsConnection",
                "kind": "LinkedField",
                "name": "__periscope__commonSuggestions_connection",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "WorkSuggestionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "kind": "FragmentSpread",
                            "name": "suggestions_periscope_WorkSuggestionsSwitcher_node"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isAutoDevJobsSuggestionEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "autoDevJobsSuggestions",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "suggestions_periscope_WorkSuggestionsAutoDevJobSwitcher_node"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isPullRequestSuggestionsEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "pullRequestSuggestions",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "suggestions_periscope_WorkSuggestionsPullRequestsSuggestionsSwitcher_node"
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isCompassSuggestionsEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "compassSuggestions",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "suggestions_periscope_WorkSuggestionsCompassSuggestionsSwitcher_node"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "WorkSuggestionsOrder",
                "kind": "LinkedField",
                "name": "sortOrder",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "defaultOrder"
                  }
                ]
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "workSuggestions"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "5e5f27294f2f0f5c6ec44b4787c4ace4";

export default node;
